import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/dSmwHNnnPFoWprT58DXrNN/ChatGPT_Image_6_feb_2026,_12_05_37_a.m..png',
    title: 'Plan Calma sin Culpa',
    label: 'Bono 1',
    description: 'Aprendé a descansar sin sentirte mal, y recuperá energía real en días.',
    value: '$9.000 ARS'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/426dz5oPEkWLKTijxyYCSA/ChatGPT_Image_6_feb_2026,_12_12_59_a.m..png',
    title: 'Mapa de Fugas Energéticas Invisibles',
    label: 'Bono 2',
    description: 'Detectá en qué puntos exactos perdés energía sin darte cuenta.',
    value: '$12.000 ARS'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/c3yCySKnfsgwzMRAhdipeZ/ChatGPT_Image_6_feb_2026,_12_13_05_a.m..png',
    title: 'Guía "Cuando Todo Pesa"',
    label: 'Bono 3',
    description: 'Herramientas de contención inmediata para días difíciles, sin agregar más tareas.',
    value: '$8.000 ARS'
  }];
  return <Section background="light-pink" className="text-center" data-id="element-32">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} data-id="element-33">
        <h2 className="text-4xl md:text-5xl font-serif italic text-navy mb-6" data-id="element-34">
          Bonos incluidos – Sin costo extra
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto mt-16" data-id="element-35">
          {bonuses.map((bonus, index) => <motion.div key={index} className="relative bg-cream p-8 rounded-[2rem] border border-dusty-rose/20 shadow-sm overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1,
          duration: 0.8,
          ease: 'easeOut'
        }} viewport={{
          once: true
        }} data-id="element-36">
              {/* Ribbon */}
              <div className="absolute top-6 left-0 z-10" data-id="element-37">
                <div className="bg-warm-gold text-white text-[10px] font-bold uppercase tracking-widest py-1.5 px-4 rounded-r-full shadow-sm" data-id="element-38">
                  SOLO POR HOY
                </div>
              </div>

              <div className="relative mb-8 aspect-[3/4] overflow-hidden rounded-[1.5rem] border border-dusty-rose/10" data-id="element-39">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-40" />
              </div>

              <p className="text-xs font-bold text-dusty-rose uppercase tracking-widest mb-3" data-id="element-41">
                {bonus.label}
              </p>
              <h3 className="text-xl font-serif italic text-navy mb-4" data-id="element-42">
                {bonus.title}
              </h3>
              <p className="text-sm text-muted font-light leading-relaxed mb-6" data-id="element-43">
                {bonus.description}
              </p>
              <p className="text-xs font-medium text-muted/70" data-id="element-44">
                Valor estimado:{' '}
                <span className="text-dusty-rose font-semibold" data-id="element-45">
                  {bonus.value}
                </span>
              </p>
            </motion.div>)}
        </div>

        {/* Total valorización */}
        <motion.div className="mt-16 inline-block bg-cream/80 backdrop-blur-md rounded-full px-10 py-4 border border-dusty-rose/30 shadow-sm" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} viewport={{
        once: true
      }} data-id="element-46">
          <p className="text-lg font-light text-navy" data-id="element-47">
            Valorización total de los bonos:{' '}
            <span className="font-serif italic font-medium text-warm-gold text-xl ml-1" data-id="element-48">
              $29.000 ARS
            </span>
          </p>
          <p className="text-sm text-muted font-light mt-1" data-id="element-49">
            Incluidos sin costo extra en el Pack Premium.
          </p>
        </motion.div>
      </motion.div>
    </Section>;
}